module.exports = __webpack_public_path__ + "img/Icon_Resume.d0763ccc.svg";